import React, { useState } from "react";

import {
  Tooltip,
  Grid,
  Stack,
  Button,
  TextField,
  Typography,
  IconButton,
  FormControl,
  Select,
  MenuItem,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
} from "@mui/material";

// import { useMutation, useQuery } from "@apollo/client"
//icons
import { CiCircleList } from "react-icons/ci";
import { FaRegEye } from "react-icons/fa";
import { BiMinusCircle } from "react-icons/bi";

//src
import "../../../Style/dialogstyle.scss";

export default function ViewAjdIn({ open, handleClose, editData }) {
  // console.log("editData", editData)

  return (
    <div>
      <Dialog open={open} className="dialog-container" fullWidth maxWidth="lg">
        <DialogTitle sx={{ padding: "10px 15px 10px 20px" }}>
          <Stack direction="row" spacing={2}>
            <Stack direction="column" justifyContent="center">
              <Typography className="dialog-title">
                ពិនិត្យការផ្ទេរចូល
              </Typography>
            </Stack>

            <Box sx={{ flexGrow: 1 }} />
            <Stack direction="column" justifyContent="center">
              <IconButton onClick={handleClose}>
                <BiMinusCircle className="close-icon" />
              </IconButton>
            </Stack>
          </Stack>
        </DialogTitle>

        <DialogContent dividers>
          <Stack
            direction="column"
            spacing={2}
            sx={{ width: "100%" }}
            className="view-dialog-contanier"
          >
            <Stack direction="row" spacing={1} className="view-header">
              <Typography className="field-title-list" sx={{ width: "10%" }} align="center">
                រូបភាព
              </Typography>
              <Typography className="field-title-list" sx={{ width: "20%" }}>
                ឈ្មោះសម្ភារៈ
              </Typography>
              <Typography className="field-title-list" sx={{ width: "20%" }}>
                ឯកតា
              </Typography>
              <Typography className="field-title-list" sx={{ width: "10%" }}>
                តម្លៃ
              </Typography>
              <Typography className="field-title-list" sx={{ width: "10%" }}>
                ចំនួន
              </Typography>
              <Typography className="field-title-list" sx={{ width: "25%" }}>
                ផ្សេងៗ
              </Typography>
            </Stack>

            {editData?.listAdjInMaterial?.map((row, index) => {
              // console.log("row",row)
              return (
                <Stack direction="row" spacing={1} key={index}>
                  
                  <Stack width="10%" direction={`row`} justifyContent="center">
                    <img
                      src={row?.listMaterialUnitId?.imageSrc}
                      alt=""
                      style={{
                        borderRadius: "10px",
                        objectFit: "cover",
                        width: "80%",
                      }}
                    />
                  </Stack>

                  <Stack width="20%" direction="column" justifyContent="center">
                    <Typography className="field-title" width="100%">
                      {row?.listMaterialUnitId?.materialId?.materialKhName}
                    </Typography>
                  </Stack>

                  <Stack width="20%" direction="column" justifyContent="center">
                    <Typography className="field-title" width="100%">
                      {row?.listMaterialUnitId?.unitId?.unitKhName}
                    </Typography>
                  </Stack>

                  <Stack width="10%" direction="column" justifyContent="center">
                    <Typography className="field-title" width="100%">
                      $ {row?.unitPrice}
                    </Typography>
                  </Stack>

                  <Stack width="10%" direction="column" justifyContent="center">
                    <Typography className="field-title" width="100%">
                      {row?.qty}
                    </Typography>
                  </Stack>

                  <Stack width="25%" direction="column" justifyContent="center">
                    <Typography className="field-title" width="100%">
                      {row?.desc}
                    </Typography>
                  </Stack>
                  
                </Stack>
              );
            })}
          </Stack>
        </DialogContent>
      </Dialog>
    </div>
  );
}
